import React from "react"
import { createIcon } from "@chakra-ui/icons"

export const TableTick = createIcon({
  displayName: "TableTick",
  viewBox: "0 0 16 12",
  defaultProps: {
    role: "img",
  },
  path: (
    <>
      <title> Table Tick Icon </title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8693 1.11528C15.0369 1.27526 15.0443 1.54208 14.8858 1.71126L6.30704 10.8681C6.22954 10.9508 6.12219 10.9984 6.00941 11C5.89663 11.0015 5.788 10.957 5.70825 10.8765L1.12233 6.24752C0.959223 6.08288 0.959223 5.81594 1.12233 5.6513C1.28544 5.48666 1.54989 5.48666 1.71299 5.6513L5.99522 9.97376L14.2789 1.13192C14.4374 0.962747 14.7017 0.955296 14.8693 1.11528Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
})
